export class DatosAdicionales{
    public constructor(
        public descripcion: String = "",
        public valor: String = "",
    ){}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/datos-adicionales.ts